import type { Step } from "../script";

export const ethocaAlerts: Step[] = [
  {
    kind: "msg",
    id: "msg-03a",
    tokens:
      "two ethoca alerts came in after 22:00. corewellness €89, matchmoment €124.",
    pauseAfter: 1100,
  },
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "ethoca" },
    pauseAfter: 1200,
  },
  {
    kind: "msg",
    id: "msg-03b",
    tokens:
      "refunding corewellness (no prior disputes). matchmoment has a strong ce3 match — submitting evidence instead. ~4× saving vs chargeback fees.",
    pauseAfter: 900,
  },
  {
    kind: "act",
    id: "act-ethoca",
    title: "ethoca · refund + evidence",
    body: "corewellness refund €89 · matchmoment evidence €124",
    receipt: "ETHOCA · 2 alerts · refund + evidence · applied",
    actMs: 5500,
  },
];
